import { useQuery } from 'react-query';
import { useBuildingIdAtom } from 'stores/building-id-atom';

import { axiosInstance } from '../axiosInstance';

export interface TransitLocationPlace {
  id: string;
  location: { lat: number; lng: number };
  name: string;
  type: string;
}

export interface DepartureResponse {
  time: number;
  transport: { headsign: string; mode: ExcludedTransportModeType; name: string; shortName: string; color: string; textColor: string };
}

export type ExcludedTransportModeType = Exclude<TransportModeType, 'ferry' | 'inclined'>;

export type TransportModeType =
  | 'highSpeedTrain'
  | 'intercityTrain'
  | 'interRegionalTrain'
  | 'regionalTrain'
  | 'cityTrain'
  | 'bus'
  | 'ferry'
  | 'subway'
  | 'lightRail'
  | 'privateBus'
  | 'inclined'
  | 'aerial'
  | 'busRapid'
  | 'monorail'
  | 'flight'
  | 'walk';


export interface TransitBoard {
  place: TransitLocationPlace;
  departures: DepartureResponse[];
}

export interface TransitDepartureResponse {
  boards: TransitBoard[];
}

export const getTransitQueryKey = (buildingId: number | null) => ['pdfs', buildingId];

const getTransit = async (buildingId: number | null) => {
  const { data } = await axiosInstance.get<TransitDepartureResponse>(`/tv-app/buildingId/${buildingId}/transit`);
  return data;
};

export const useGetTransit = () => {
  const [buildingId] = useBuildingIdAtom();

  return useQuery({
    enabled: !!buildingId,
    queryKey: getTransitQueryKey(buildingId),
    queryFn: () => getTransit(buildingId),
    refetchOnWindowFocus: false,
    // Note: refetch every 1 minute
    refetchInterval: 1 * 60 * 1000,
    refetchIntervalInBackground: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
